import { useEffect } from "react";

const LinkedInTracking = () => {
  useEffect(() => {
    // Script 1: Initialize LinkedIn partner ID
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.textContent = `
      window._linkedin_partner_id = "3311561";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
    `;
    document.body.appendChild(script1);

    // Script 2: Load LinkedIn Insight script
    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.textContent = `
      (function(l) {
        if (!l) {
          window.lintrk = function(a, b) { window.lintrk.q.push([a, b]) };
          window.lintrk.q = [];
        }
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);
    `;
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        alt=""
        src="https://px.ads.linkedin.com/collect/?pid=3311561&fmt=gif"
      />
    </noscript>
  );
};

export default LinkedInTracking;